import React, { FC } from 'react';

import Button, { ButtonGroup } from '@adsk/alloy-react-button';
import { GridIcon, MenuIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { ATTACHMENTS_LIST_VARIANTS } from '../../consts';
import type { AttachmentListVariant } from '../../types';

type AttachmentsListViewToggleProps = {
  selected: AttachmentListVariant;
  onSelect: (nextSelectedViewType: AttachmentListVariant) => void;
};

const AttachmentsListViewToggle: FC<AttachmentsListViewToggleProps> = ({
  selected,
  onSelect,
}) => (
  <ButtonGroup
    data-testid="AttachmentsListViewToggle"
    size="small"
    value={Object.values(ATTACHMENTS_LIST_VARIANTS).indexOf(selected)}
    style={{
      justifyContent: 'flex-end',
      padding: `${theme.spacing.xSmall}px ${theme.spacing.medium}px`,
      '&:hover': {
        boxShadow: 'none',
      },
    }}
  >
    <Button
      onClick={() => onSelect(ATTACHMENTS_LIST_VARIANTS.GRID)}
      renderIcon={(props) => GridIcon.renderIcon({ ...props, size: 16 })}
      data-testid={`AttachmentsListViewToggle_${ATTACHMENTS_LIST_VARIANTS.GRID}`.concat(
        selected === ATTACHMENTS_LIST_VARIANTS.GRID ? '_selected' : '',
      )}
    />
    <Button
      onClick={() => onSelect(ATTACHMENTS_LIST_VARIANTS.LIST)}
      renderIcon={(props) => MenuIcon.renderIcon({ ...props, size: 16 })}
      style={{ borderLeft: 'none' }}
      data-testid={`AttachmentsListViewToggle_${ATTACHMENTS_LIST_VARIANTS.LIST}`.concat(
        selected === ATTACHMENTS_LIST_VARIANTS.LIST ? '_selected' : '',
      )}
    />
  </ButtonGroup>
);

export default AttachmentsListViewToggle;
